module.exports = function _of(x) { return [x]; };



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_of.js
// module id = ./node_modules/ramda/src/internal/_of.js
// module chunks = 54 55 56